export default __webpack_public_path__ + "static/media/7h.a4e62830.svg";